module.exports = __webpack_public_path__ + "static/img/alarmopen.c37618ad.png";